export default __webpack_public_path__ + "static/media/Flag_of_Kosovo.e7343fa7.svg";